import React from "react";
import Header from "../Global/Header";
import { Link } from "react-router-dom";
import { Path } from "../Path";
import Carousels from "../Components/Mainpage/Carousels";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Roadmap from "../Components/Mainpage/Roadmap";
import FAQs from "../Components/Mainpage/FAQS";
import Designers from "./Designers";

// const videosrc = "http://developerssupport.com/video_link/02.mp4";

// const videosrc = Path + "06.mp4";

export function Mainlandingmob() {
  return (
    <>
      {/* Banner */}
      <div id="main_banner" className="container-fluid">
        <Header />
        <div className="row">
          <h2 className="heading main_banner-heading">
            Sharing your passion for
            <br /> finance, business and art.
          </h2>
          <p className="para-sub main_banner-para">
            Enter the world of billionaires and benefit from staking your NFT,
            earning <br />
            $LITTLE and MATIC on a daily basis and countless other utilities and
            benefits
          </p>

          <ul className="price-phrase main_banner-list main_banners">
            <li>
              <Link to="/little-token" className="whitepaper">
                <button className="custom-btn btn-banner header">
                  $LITTLE TOKEN
                </button>
              </Link>
            </li>
            <li>
              <a
                href={Path + "Whitepaper_FINAL_1.1-2.pdf"}
                target="_blank"
                className="whitepaper" rel="noreferrer"
              >
                <button className="custom-btn btn-banner header">
                  Whitepaper
                </button>
              </a>
            </li>
            <li onClick={() => window.open("https://discord.gg/7UD5mSxSSW")}>
              <button className="custom-btn btn-banner header discord-btn">
                Discord
              </button>
            </li>
          </ul>
        </div>

        <div className="row main_banner-row">
          <img className="three-person" alt="imaggee" src={"images/new/2.png"} />
        </div>
      </div>

      {/* Banner */}

      {/* Billionaires */}

      <div id="billionaires" className="container-fluid">
        <div className="row">
          <div className="col-sm-7">
            <h1 className="banner-head billion_heading main_billion_head">
              What is <br />
              <img src={"images/new/billion-logo.png"} alt="billion-logo" className="billi_logo" />
              ?
            </h1>
            <b>
              <div className="col-sm-5 picture">
                <img src={"images/team2.png"} alt="team-imag" className="billio_img floating" />
              </div>
              <p className="banner-para billio_para-first first">
                <b>Little Billionaires </b>is a generative 3D art NFT project
                with the main focus on added value for the holder
              </p>
            </b>
            <p className="banner-para billio_para-second">
              Little Billionaires provides you with a state-of-the-art ecosystem
              circulating around the <b>$LITTLE</b> token, which finds its added
              value in a variety of use cases even before the official listing
            </p>
            <Link to="/little-token">
              <button className="custom-btn btn-banner billion_button header" style={{width:"154px"}}>
                WHAT'S $LITTLE TOKEN
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Billionaires */}

      {/* Mint */}

      <div id="main_become" className="container-fluid">
        <div className="row main_become-row">
          <div className="col-sm-4">
            <div className="price-section">
              <article className="price-table">
                <img src={"images/new/5.1.png"} alt="card" className="cards" />
                <h3 className="utilities-head">Mint Your </h3>
                <h3 className="little__heading"> Little Billionaire</h3>

                <p className="little_para main_para">
                  Mint from a unique collection of 7,777 collectibles and
                  benefit from their utilities.
                </p>
              </article>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="price-section">
              <article className="price-table">
                <img src={"images/new/5.2.png"} alt="stake-img" className="cards" />
                <h3 className="utilities-head">Stake Your</h3>
                <h3 className="little__heading"> Little Billionaire</h3>
                <p className="little_para para__little main_para">
                  Stake your NFT after the mint and receive between 50 and 300
                  $LITTLE tokens every day.
                </p>
              </article>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="price-section">
              <article className="price-table">
                <img src={"images/new/5.3.png"} alt="benefit-img" className="cards" />
                <h3 className="utilities-head">Benefit Like a </h3>
                <h3 className="little__heading">Little Billionaire</h3>

                <p className="little_para main_para">
                  Benefit from the variety of utilities, join the Billionaires
                  Club and be a part of a<br /> promising future.
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>

      {/* Mint */}

      {/* Carousel */}

      <Carousels />
      {/* Carousel */}

      {/* Mobile Utilities */}

      <div id="teams" className="container-fluid fq">
        <h2 className="main_banner-heading utilities__heading head_pt">
          Utilities for Holders & User Benefits
        </h2>
        <p className="para-sub team_para faq__para">
          Little Billionaires offers the owner a multitude of advantages and
          benefits for holders
        </p>
        <div className="row faq-row">
          <div className="col-6 faq-column">
            <div className="row dropdown_row">
              <div className="col-2">
                <img className="faq_imgs" alt="faq-img" src={"images/new/7.1.png"} />
              </div>
              <div className="col-10">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      {" "}
                      Staking{" "}
                      <span className="utilities_arrow">
                        <img src={"images/new/arroww.png"} alt="arrow-img"></img>
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="typo">
                      Each Little Billionaire holder can lock their NFTs in the
                      internal staking program for any amount of time. By
                      staking your Little Billionaires you will be rewarded with
                      $LITTLE tokens daily. Depending on the rarity of your NFT,
                      the staking rewards can be even higher than usual. Your
                      NFT and your rewards can be withdrawn from the staking
                      program at any time
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="col-2"></div>
            </div>
            <div className="row dropdown_row">
              <div className="col-2">
                <img className="faq_imgs" alt="faq-imgg" src={"images/new/7.2.png"} />
              </div>
              <div className="col-10">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      Get rewarded for Hodl $LITTLE{" "}
                      <span className="utilities_arrow">
                        <img src={"images/new/arroww.png"} alt="arrow-img"></img>
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="typo">
                      The $LITTLE token is the internal currency of the Little
                      Billionaires and will be the means of payment for one of
                      the largest decentralized marketplaces for gaming and
                      digital art NFTs. By staking your NFTs you will receive
                      $LITTLE every day. If you hold these, you will be paid
                      daily with MATIC tokens on your wallet.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="col-2"></div>
            </div>
            <div className="row dropdown_row">
              <div className="col-2">
                <img className="faq_imgs" alt="faqq-imgg" src={"images/new/7.3.png"} />
              </div>
              <div className="col-10">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      Little Billionaires Club{" "}
                      <span className="utilities_arrow">
                        <img src={"images/new/arroww.png"} alt="arrow-imge"></img>
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="typo">
                      As a Little Billionaire you get exclusive access to a
                      unique club with internal events, exclusive parties and
                      VIP entry to selected clubs around the world. You will
                      also become part of an internal expert community. You are
                      joining an exclusive group of people including global
                      experts and celebrities that share your passion for
                      finance, business and art.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="col-2"></div>
            </div>
            <div className="row dropdown_row">
              <div className="col-2">
                <img className="faq_imgs" alt="faq-imag" src={"images/new/7.4.png"} />
              </div>
              <div className="col-10">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      Explore Metaverse{" "}
                      <span className="utilities_arrow">
                        <img src={"images/new/arroww.png"} alt="arrow-imag"></img>
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="typo">
                      Metaverse and virtual reality are without a doubt the
                      future. Slip into your little billionaire in the Metaverse
                      and bring him to life. All Little Billionaires will be
                      fully equipped for their use in the Metaverse. You will be
                      able to see your Little Billionaire as 3D avatar in games,
                      movies and several Metaverses.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="col-2"></div>
            </div>
          </div>

          <div className="col-6 faq-column">
            <div className="row dropdown_row">
              <div className="col-2">
                <img className="faq_imgs" alt="faq-imag" src={"images/new/7.5.png"} />
              </div>
              <div className="col-10">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      Digital Swap{" "}
                      <span className="utilities_arrow">
                        <img src={"images/new/arroww.png"} alt="arrow-imag"></img>
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="typo">
                      As you already know, you can stake your Little
                      Billionaires and earn $LITTLE on a daily basis. You can
                      exchange your $LITTLE for other cryptocurrencies such as
                      MATIC on our digital exchange and withdraw them to your
                      chosen wallet. More exchangeable tokens will come in the
                      future.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="col-2"></div>
            </div>
            <div className="row dropdown_row">
              <div className="col-2">
                <img className="faq_imgs" alt="faq-imag" src={"images/new/7.6.png"} />
              </div>
              <div className="col-10">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      $LITTLE Airdrop{" "}
                      <span className="utilities_arrow">
                        <img src={"images/new/arroww.png"} alt="arrow-imag"></img>
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="typo">
                      Each NFT holder will receive a $LITTLE Airdrop after
                      minting their NFTs. For each NFT minted, each user gets
                      1,000 $LITTLE credited to their balance.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="col-2"></div>
            </div>
            <div className="row dropdown_row">
              <div className="col-2">
                <img className="faq_imgs" alt="faq-imag" src={"images/new/7.7.png"} />
              </div>
              <div className="col-10">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      IPO Whitelisting spot{" "}
                      <span className="utilities_arrow">
                        <img src={"images/new/arroww.png"} alt="arrow-imag"></img>
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="typo">
                      The $LITTLE token will be sold in an IPCO in Q2 2022 and
                      made available to the public. As a Little Billionaire NFT
                      holder, you get the opportunity to get a discounted price
                      before everyone else in the presale and are guaranteed to
                      be able to count to the first $LITTLE holders before it is
                      listed on the stock exchange.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="col-2"></div>
            </div>

            <div className="row dropdown_row">
              <div className="col-2">
                <img className="faq_imgs" alt="faq-imag" src={"images/new/7.8.png"} />
              </div>
              <div className="col-10">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      Take part in Giveaways{" "}
                      <span className="utilities_arrow">
                        <img src={"images/new/arroww.png"} alt="arrow-imag"></img>
                      </span>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className="typo">
                      Our Little Billionaires have a lot of giveaways planned
                      for the community. Some of these are exclusive to
                      legendary holders. Most, however, are raffled among the
                      entire community.
                      <br /> As an NFT holder, you automatically <br />
                      take part in these raffles
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className="col-2"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Utilities */}

      {/* Roadmap */}

      <Roadmap />

      {/* Roadmap */}

      {/* Meet designer */}
      <div id="designer" className="container-fluid">
        <h2 className="head_pt main_banner-heading mob_designers">
          Meet our Designers & the Team
        </h2>
        <div className="paragraphs">
          <p className="experience">
            Our Team having a ton of experience will provide
          </p>
          <p className="best"> you with the best quality you will be able</p>
          <p className="able">to find. They are talented, motivated and</p>
          <p className="rock">ready to rock the NFT world with you.</p>
        </div>

        <div className="row main_small_team" style={{ display: "none" }}>
          <div className="col-sm-7 team_info">
            <h1 className="banner-head billion_heading mob-idea">
              Idea, concept and design
            </h1>
            <b></b>
            <p className="banner-para team_para">
              {/* The idea of Little Billionaires is based on a mixture of <br />
              the current NFT trends and something bold, something new <br />
              and unprecedented, which should reflect a new style and <br />a
              new idea. Not only a mix of photorealistic assets and <br />a main
              3D character varying positions and unique assets
              <br /> brings together elements that are in clear harmony */}
              The idea of Little Billionaires is based on a mixture of the
              current NFT trends and something bold, something new and
              unprecedented, which should reflect a new style and a new idea.
              Not only a mix of photorealistic assets and a main 3D character
              varying positions and unique assets brings together elements that
              are in clear harmony
            </p>
            <div>
              <ul className="social-team">
                <li
                  className="social-team_list"
                  onClick={() =>
                    window.open("https://twitter.com/LittleBillions")
                  }
                >
                  <Link to="/">
                    <img
                      src={"images/twit-head.png"}
                      className="head-social effecthov"
                      alt="twitter"
                    />
                  </Link>
                </li>
                <li
                  className="social-team_list"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/littlebillionaires.io/"
                    )
                  }
                >
                  <Link to="/">
                    <img
                      src={"images/insta-head.png"}
                      className="head-social effecthov"
                      alt="insta"
                    />
                  </Link>
                </li>
                <li
                  className="social-team_list"
                  onClick={() => window.open("https://discord.gg/7UD5mSxSSW")}
                >
                  <Link to="/">
                    <img
                      src={"images/dis-head.png"}
                      className="head-social effecthov"
                      alt="dis"
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-sm-5 picture">
            <Designers />
            {/* <img src={"images/new/12.png"} className="team_img floating" /> */}
          </div>
        </div>
      </div>

      {/* Meet designer */}

      {/* Future Plans */}

      <div id="future" className="container-fluid">
        <h2 className="head_pt future_heading">Future plans</h2>

        <div className="row future_row">
          <div className="col-sm-5 picture picture1">
            {/* <video
              width="350"
              height="350"
              controls={false}
              autoplay="autoplay"
              loop={true}
            >
              <source src="images/02.mp4" type="video/mp4" />
            </video> */}
            {/* <div
              dangerouslySetInnerHTML={{
                __html: `<video loop muted autoplay playsinline src="${videosrc}" id="myVideo"/>`,
              }}
              style={{ padding: "0" }}
            ></div> */}
            <img
              src={"images/06_new.gif"}
              className="team_img future-img floating"
              alt="floating"
            />
          </div>
          <div className="col-sm-7 future_info" style={{ margin: "auto" }}>
            <h5 className="">Metaverse usability</h5>
            <b></b>
            <p className="banner-para future_para">
              As already mentioned, every<b> Little Billionaire</b> will have
              the opportunity to see their character or characters again in
              various metaverses. Whether as a 3D avatar in games, movies, or
              other metaverse projects, it will maintain an ongoing connection
              to the metaverse for use by holders in the future <br />
              of the little billionaires.
            </p>

            <h5 className="wives">Little Billionaire Wives</h5>
            <b></b>
            <p className="banner-para future_para">
              What would a true billionaire or the woman at his side be? In Q4
              2022, the Billionaire family will be expanded. Our billionaires
              get their wives who will accompany them on the way. For the
              community, this means a host of new utilities, new ways to stake
              or be rewarded, and a variety of <br />
              limited Holder Access Only passes. The Little Billionaires Wives
              launch will be announced on social media. Keep your eyes peeled
              for Sneak Peaks.
            </p>
            <div></div>
          </div>
        </div>
      </div>
      {/* Future Plans */}

      <FAQs />

      {/* Footer */}

      <footer className="mainfooter" role="contentinfo">
        <div className="footer-middle">
          <div className="container footer">
            <div className="row footer">
              <div className="col-sm-6">
                {/* <!--Column1--> */}

                <div className="footer-pad mob-pad">
                  <Link to={"/"}>
                    <img
                      src={"images/logo.png"}
                      className="foot-logo mob_footlogo"
                      alt="foot-logo"
                    />
                  </Link>
                  <p className="foot-text">
                    7,777 unique billionaires who need owners.
                  </p>
                </div>
              </div>

              <div className="list-footer">
                <ul className="footer_list">
                  <li>
                    <div className="footer-pad">
                      <h4>DOWNLOAD</h4>
                      <ul className="list-unstyled">
                        <li>
                          {/* <Link to="/">Whitepaper</Link> */}
                          <a
                            href={Path + "Whitepaper_FINAL_1.1-2.pdf"}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Whitepaper
                          </a>
                        </li>
                        {/* <li><Link to="/">Login</Link></li>
            <li><Link to="/">Register</Link></li>
            <li><Link to="/">Dashboard</Link></li>
            <li><Link to="/">Forgot Password</Link></li> */}
                      </ul>
                    </div>
                  </li>

                  <li>
                    <div className="social_links">
                      <h4>Social</h4>
                      <ul className="social-network social-circle">
                        <li>
                          <Link to="/">
                            <ul
                              className="social icons_social"
                              onClick={() =>
                                window.open(
                                  "https://twitter.com/LittleBillions"
                                )
                              }
                            >
                              <li className="foot-social effecthov">
                                <img src={"images/twit-head.png"} alt="twit"/>
                              </li>
                              <li className="foot-social">Twitter</li>
                            </ul>
                          </Link>
                        </li>
                        <li>
                          <Link to="/">
                            <ul
                              className="social icons_social"
                              onClick={() =>
                                window.open(
                                  "https://www.instagram.com/littlebillionaires.io/"
                                )
                              }
                            >
                              <li className="foot-social effecthov">
                                <img src={"images/insta-head.png"} alt="isnta"/>
                              </li>
                              <li className="foot-social">Instagram</li>
                            </ul>
                          </Link>
                        </li>

                        <li>
                          <Link to="/">
                            <ul
                              className="social icons_social"
                              onClick={() =>
                                window.open("https://discord.gg/7UD5mSxSSW")
                              }
                            >
                              <li className="foot-social effecthov">
                                <img
                                  src={"images/dis-head.png"}
                                  style={{ marginTop: "-4px" }}
                                  alt="dis"
                                />
                              </li>
                              <li className="foot-social">Discord</li>
                            </ul>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="row">
                <div className="col-md-12 copy">
                  <p className="text-center mob-pcenter">
                    &copy; Copyright 2022 - Little Billionaires. All rights
                    reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Footer */}
    </>
  );
}
